import Vue from 'vue';


const updateStudentsCompleteStatus = async (contactTypes) => {

    let contactTypeIds = null;
    if(Array.isArray(contactTypes)){
        const studentContactTypes = contactTypes.filter(t => t.is_customer && t.has_student);
        contactTypeIds = studentContactTypes && studentContactTypes.length > 0 ? studentContactTypes.map(t => t.id):null;
    }
    else{
        contactTypeIds = [contactTypes]
    }

    if(contactTypeIds){
        const data = {
            contactTypeIds
        };
        return await Vue.axios.put("/student/update-complete-status", data)
    }
}


const updateStaffCompleteStatus = async (contactTypes) => {
    let contactTypeIds = null;
    if(Array.isArray(contactTypes)){
        const staffContactTypes = contactTypes.filter(t => t.is_staff);
        contactTypeIds = staffContactTypes && staffContactTypes.length > 0 ? staffContactTypes.map(t => t.id):null;
    }
    else{
        contactTypeIds = [contactTypes]
    }

    if(contactTypeIds){
        const data = {
            contactTypeIds
        };
        return await Vue.axios.put("/staff/update-complete-status", data)   
    }
}


export {
    updateStudentsCompleteStatus,
    updateStaffCompleteStatus
}